// Anti-repeat memory for the Live Radio. Tracks the IDs of songs the listener
// heard in the last few hours (per-device, localStorage). The Radio queue
// fetch sends this as `?exclude=<csv>` so the backend skips them when
// possible — falls back to the full library if the exclusion would starve
// the queue.
//
// Cap is intentionally LARGER than a single fetch batch (60) so that even
// after auto-replenish the listener keeps seeing fresh tracks. Entries
// older than RECENT_TTL_MS auto-expire on the next read.

const KEY = "yahweh_recent_played";
const MAX_ENTRIES = 120;
const RECENT_TTL_MS = 4 * 60 * 60 * 1000; // 4 hours

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    const now = Date.now();
    return arr.filter((e) => e && e.id && (now - (e.t || 0)) < RECENT_TTL_MS);
  } catch {
    return [];
  }
}

function writeAll(entries) {
  try {
    localStorage.setItem(KEY, JSON.stringify(entries.slice(0, MAX_ENTRIES)));
  } catch {
    // Quota or private-mode — silently ignore; the radio still works.
  }
}

export function noteRecentlyPlayed(trackId) {
  if (!trackId) return;
  const list = readAll().filter((e) => e.id !== trackId);
  list.unshift({ id: trackId, t: Date.now() });
  writeAll(list);
}

export function recentlyPlayedIds() {
  return readAll().map((e) => e.id);
}

export function clearRecentlyPlayed() {
  try { localStorage.removeItem(KEY); } catch { /* noop */ }
}
